import React from 'react';

const ComingSoonBadge = (props) => {
  return (
    <img
      {...props}
      alt="Made with our friends Coming Soon"
      src="https://cdn.shopify.com/s/files/1/0051/6295/8946/files/partnership_coming-soon.png"
    />
  );
};

export default ComingSoonBadge;
